import store from '@/store'
import guards from './guards'

const clientRoutes = {
  path: '/client',
  name: 'clientDashboard',
  meta: {
    name: 'dashboard'
  },
  beforeEnter: (to, from, next) => guards.dashboardGuard(next),
  component: () => import(/* webpackChunkName: 'client' */ '@/pages/client/Dashboard.vue'),
  children: [
    {
      path: 'edit',
      name: 'clientEditProfile',
      meta: {
        name: 'clientEditProfile'
      },
      component: () => import(/* webpackChunkName: 'client-profile' */ '@/pages/client/EditProfile.vue')
    },
    {
      path: 'product_registrations',
      name: 'productRegistrations',
      meta: {
        name: 'productRegistrations'
      },
      beforeEnter: (to, from, next) => store.dispatch('firstFetchPR').then(() => next()),
      component: () => import(/* webpackChunkName: 'product-registration' */ '@/pages/client/product_registrations/ProductRegistrations.vue')
    },
    {
      path: 'product_registrations/:id',
      name: 'productRegistrationForm',
      meta: {
        name: 'productRegistrations'
      },
      beforeEnter: (to, from, next) => guards.prFormGuard(to, next),
      props: true,
      component: () => import(/* webpackChunkName: 'product-registration' */ '@/pages/client/product_registrations/ProductRegistrationForm.vue')
    },
    {
      path: 'product_registrations/:id/review',
      name: 'productRegistrationReview',
      meta: {
        name: 'productRegistrations'
      },
      beforeEnter: (to, from, next) => guards.prReviewGuard(to, next),
      props: true,
      component: () => import(/* webpackChunkName: 'product-registration-review' */ '@/pages/client/product_registrations/ProductRegistrationReview.vue')
    },
    {
      path: 'support_requests',
      name: 'supportRequests',
      meta: {
        name: 'supportRequests'
      },
      beforeEnter: (to, from, next) => store.dispatch('firstFetchPR').then(() => next()),
      component: () => import(/* webpackChunkName: 'support-request' */ '@/pages/client/support_requests/SupportRequests.vue')
    },
    {
      path: 'support_requests/new',
      name: 'supportRequestForm',
      meta: {
        name: 'supportRequests'
      },
      beforeEnter: (to, from, next) => guards.srFormGuard(to, next),
      component: () => import(/* webpackChunkName: 'support-request-form' */ '@/pages/client/support_requests/SupportRequestForm.vue')
    },
    {
      path: 'support_requests/:id/review',
      name: 'supportRequestReview',
      meta: {
        name: 'supportRequests'
      },
      beforeEnter: (to, from, next) => guards.srReviewGuard(to, next),
      props: true,
      component: () => import(/* webpackChunkName: 'support-request-review' */ '@/pages/client/support_requests/SupportRequestReview.vue')
    },
    {
      path: 'reviews',
      name: 'reviews',
      meta: {
        name: 'reviews'
      },
      beforeEnter: (to, from, next) => store.dispatch('firstFetchReviews').then(() => next()),
      component: () => import(/* webpackChunkName: 'reviews' */ '@/pages/client/reviews/Reviews.vue')
    },
    {
      path: 'contact',
      name: 'clientContact',
      meta: {
        name: 'contact'
      },
      component: () => import(/* webpackChunkName: 'client-contact' */ '@/pages/client/Contact.vue')
    },
    {
      path: '*',
      name: 'client404',
      meta: {
        from: 'client'
      },
      component: () => import(/* webpackChunkName: 'page-404' */ '@/pages/Page404.vue')
    }
  ]
}

export default clientRoutes
